import React from "react";
import { Link } from "react-router-dom";
import { ReactComponent as InicarSesionIconB } from "../../assets/icons/IniciarSesion(b).svg"
import { ReactComponent as InicarSesionIcon } from "../../assets/icons/IniciarSesion.svg"
import LogoutIconB from "../../assets/icons/Salir(A).svg"
import LogoutIcon from "../../assets/icons/Salir.svg"
import HomeIconB from "../../assets/icons/Home PAG(A).svg"
import HomeIcon from "../../assets/icons/Home PAG.svg"
import OtrosSistemasIconB from "../../assets/icons/Otros Sistemas(A).svg"
import OtrosSistemasIcon from "../../assets/icons/Otros Sistemas.svg"
import { msalInstance } from "helpers/EntraID/msalInstance";
import { loginRequest } from "helpers/EntraID/authConfig";
import {
    Collapse,
    Navbar,
    NavbarToggler,
    NavbarBrand,
    Nav,
    NavItem,
    Dropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
    Container,
    Col,
    Row,
    InputGroup,
    InputGroupText,
    InputGroupAddon,
    Input,
} from "reactstrap";

//import * as $ from 'jquery'; 
//window.$ = jQuery;
import routes from "routes.js";
import logo from "./../../assets/img/logo.png";
//import wg_espol from "./../../assets/js/wg_espol";
import configData from "./../../config.json";
import { history } from './../../helpers/history';
import { authenticationService } from '../../services/authentication.service';
import Icons from "views/Icons";
import { bool } from "prop-types";

class Header extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            currentUser: null,
            isAdmin: false,
            nombres: "",
            apellidos: "",
            isOpen: false,
            dropdownOpen: false,
            color: "transparent",
            srcLogoutIcon: LogoutIcon,
            srcHomeIcon: HomeIcon,
            srcSistemasIcon: OtrosSistemasIcon
        };
        this.myRef = React.createRef();


    }



    sidebarToggle = React.createRef();
    toggle = () => {
        if (this.state.isOpen) {
            this.setState({
                color: "transparent",
            });
        } else {
            this.setState({
                color: "white",
            });
        }
        this.setState({
            isOpen: !this.state.isOpen,
        });
    };
    dropdownToggle = (e) => {
        this.setState({
            dropdownOpen: !this.state.dropdownOpen,
        });
    };
    getBrand = () => {
        var name;
        routes.map((prop, key) => {
            if (prop.collapse) {
                prop.views.map((prop, key) => {
                    if (prop.path === this.props.location.pathname) {
                        name = prop.name;
                    }
                    return null;
                });
            } else {
                if (prop.redirect) {
                    if (prop.path === this.props.location.pathname) {
                        name = prop.name;
                    }
                } else {
                    if (prop.path === this.props.location.pathname) {
                        name = prop.name;
                    }
                }
            }
            return null;
        });
        return name;
    };
    openSidebar = () => {
        document.documentElement.classList.toggle("nav-open");
        this.sidebarToggle.current.classList.toggle("toggled");
    };
    // function that adds color white/transparent to the navbar on resize (this is for the collapse)
    updateColor = () => {
        if (window.innerWidth < 993 && this.state.isOpen) {
            this.setState({
                color: "white",
            });
        } else {
            this.setState({
                color: "transparent",
            });
        }
    };
    logout() {
        //this.props.onLogoutIndex();
        authenticationService.logout();
        // history.push('/Account/Logout');
       
    }

    async login() {
        // window.location = "/Account/Login";
        const response = await msalInstance.loginRedirect(loginRequest);
        
    }

    activarWidget = () => {

        this.myRef.current.click();
    }


    componentDidMount() {
        // authenticationService.currentUser.subscribe(x => this.setState({
        //     currentUser: x,
        // }));

        this.setState({ currentUser: authenticationService.currentUserValue })

        window.addEventListener("resize", this.updateColor.bind(this));

        //const script = document.createElement("script");
        //script.src = src_script;
        ////script.src = "https://www.profesor.espol.edu.ec/Scripts/wg_sistemas/wg_espol.js?"
        ////script.type = "babel";
        //document.body.appendChild(script);

        //$(document).find("#widgetsistemas").sistemasEspol();

    }
    componentDidUpdate(e) {
        if (e.history) {
            if (
                window.innerWidth < 993 &&
                e.history.location.pathname !== e.location.pathname &&
                document.documentElement.className.indexOf("nav-open") !== -1
            ) {
                document.documentElement.classList.toggle("nav-open");
                this.sidebarToggle.current.classList.toggle("toggled");
            }
            else if (
                window.innerWidth < 993 &&
                document.documentElement.className.indexOf("nav-open") !== -1
            ) {
                document.documentElement.classList.toggle("nav-open");
            }
        }

    }
    render() {

        let existe_dato_usuario = this.state.currentUser && this.state.currentUser.usuario;
        const iconos_navegacion =
            <React.Fragment>
                <Col xl={{ size: 1, offset: 8 }}>

                </Col>
                <Col xl={4} >
                    <div className="row mt-2" style={{ float: "right" }}>
                        <span className="mr-2" id="menu_espol">

                            <a id="widgetsistemas" className="nav-item nav-link" ref={this.myRef} hidden={true} title="Aplicaciones" style={{ color: "#FFC200" }}></a>
                        </span>

                        <img className={"otrosSistemasIcon pr-2"} onClick={() => this.activarWidget()} onMouseLeave={() => this.setState({ srcSistemasIcon: OtrosSistemasIcon })} onMouseEnter={() => this.setState({ srcSistemasIcon: OtrosSistemasIconB })} src={this.state.srcSistemasIcon} alt="OtrosSistemaIcon" />
                        <img className={"homeIcon pr-2"} onMouseLeave={() => this.setState({ srcHomeIcon: HomeIcon })} onMouseEnter={() => this.setState({ srcHomeIcon: HomeIconB })} src={this.state.srcHomeIcon} onClick={() => window.location = "/web"} alt="HomeIcon" />
                        <img className={"logoutIcon mr-2"} onMouseLeave={() => this.setState({ srcLogoutIcon: LogoutIcon })} onMouseEnter={() => this.setState({ srcLogoutIcon: LogoutIconB })} onClick={() => this.logout()} src={this.state.srcLogoutIcon} alt="LogoutIcon" />

                    </div>
                </Col>

            </React.Fragment>

        return (
            // add or remove classes depending if we are on full-screen-maps page or not
            <React.Fragment>
                <Navbar
                    //color={
                    //    this.props.location.pathname.indexOf("full-screen-maps") !== -1
                    //        ? "white"
                    //        : this.state.color
                    //}
                    style={{ backgroundColor: "#243165", minHeight: "120px", borderBottom: "solid 2px #FFC200" }}
                    expand="lg"

                //className={
                //    this.props.location.pathname.indexOf("full-screen-maps") !== -1
                //        ? "fixed-top"
                //        : "fixed-top "
                //}
                >
                    <Container fluid >
                        <a>
                            <img className="pull-left logoespol" src={logo} alt="ESPOL" title="ESPOL" />
                        </a>
                        <div className="pt-2 " style={{ float: "left", color: "#FFC200" }}>{/*console.log('currentuser=' + JSON.stringify(this.state.currentUser))*/}
                            <div className="row">
                                {this.state.currentUser && this.state.currentUser.usuario ? (this.state.currentUser.nombres + " " + this.state.currentUser.apellidos) : ''}
                            </div>
                            <div className="row mt-2" >
                                {/* <span className="mr-2" id="menu_espol">
                                <a id="widgetsistemas" className="nav-item nav-link" title="Aplicaciones" style={{ color: "#FFC200" }}></a></span> */}

                                {/* <span className="mr-2" id="menu_espol">
                                <a id="widgetsistemas" className="nav-item nav-link widget" title="Aplicaciones" style={{ color: "#FFC200" }}></a></span> */}
                                {
                                    //<div className="wg_espol_dropdown_login wg_espol_dropdown_menu wg_espol_dropdown_menu_right">
                                    //    <div className="wg_espol_triang_sup">
                                    //    </div>
                                    //    <div className="row wg_espol_body_portal_imagen_min">
                                    //        <div className="wg_espol_block_portal">
                                    //            <a className="wg_a" style={{ padding: "0 !important" }} href="https://www.profesor.espol.edu.ec" title="Cick para acceder al sistema de Profesor">
                                    //                <img src="https://www.profesor.espol.edu.ec/Content/Images/portal_min/profesor_min.png" alt="Profesor" className="block-portal-imagen" style={{ borderColor: "#F5b400" }} />
                                    //            </a>
                                    //        </div>
                                    //        <div className="wg_espol_block_portal">
                                    //            <a className="wg_a" style={{ padding: "0 !important" }} href="http://consejerias.espol.edu.ec" title="Cick para acceder al sistema de Consejerías">
                                    //                <img src="https://www.profesor.espol.edu.ec/Content/Images/portal_min/consejerias_min.png" alt="Consejerías" className="block-portal-imagen" style={{ borderColor: "#25223f" }} />
                                    //            </a>
                                    //        </div>
                                    //        <div className="wg_espol_block_portal">
                                    //            <a className="wg_a" style={{ padding: "0 !important" }} href="http://investigacion.espol.edu.ec/Account/LogOn" title="Cick para acceder al sistema de Investigación">
                                    //                <img src="https://www.profesor.espol.edu.ec/Content/Images/portal_min/investigacion_min.png" alt="Investigación" className="block-portal-imagen" style={{ borderColor: "#808080" }} />
                                    //            </a>
                                    //        </div>
                                    //    </div>
                                    //    <div className="row wg_espol_body_portal_imagen_min">
                                    //        <div className="wg_espol_block_portal">
                                    //            <a className="wg_a" style={{ padding: "0 !important" }} href="https://www.sidweb.espol.edu.ec/" title="Cick para acceder al sistema de Sidweb">
                                    //                <img src="https://www.profesor.espol.edu.ec/Content/Images/portal_min/sidweb_min.png" alt="Sidweb" className="block-portal-imagen" style={{ borderColor: "#d2d2d2" }} />
                                    //            </a>
                                    //        </div>
                                    //        <div className="wg_espol_block_portal">
                                    //            <a className="wg_a" style={{ padding: "0 !important" }} href="http://www.vinculos.espol.edu.ec/" title="Cick para acceder al sistema de Vínculos">
                                    //                <img src="https://www.profesor.espol.edu.ec/Content/Images/portal_min/vinculos_min.png" alt="Vínculos" className="block-portal-imagen" style={{ borderColor: "#F5b400" }} />
                                    //            </a>
                                    //        </div>
                                    //        <div className="wg_espol_block_portal">
                                    //            <a className="wg_a" style={{ padding: "0 !important" }} href="http://evaluaciondocente.espol.edu.ec/inicio" title="Cick para acceder al sistema de Evaluación">
                                    //                <img src="https://www.profesor.espol.edu.ec/Content/Images/portal_min/evaluacion_min.png" alt="Evaluación" className="block-portal-imagen" style={{ borderColor: "#25223f" }} />
                                    //            </a>
                                    //        </div>
                                    //    </div>
                                    //    <div className="row wg_espol_body_portal_imagen_min">
                                    //        <div className="wg_espol_block_portal">
                                    //            <a className="wg_a" style={{ padding: "0 !important" }} href="https://mail.espol.edu.ec" title="Cick para acceder al sistema de Correo">
                                    //                <img src="https://www.profesor.espol.edu.ec/Content/Images/portal_min/correo_min.png" alt="Correo" className="block-portal-imagen" style={{ borderColor: "#808080" }} />
                                    //            </a>
                                    //        </div>
                                    //        <div className="wg_espol_block_portal">
                                    //            <a className="wg_a" style={{ padding: "0 !important" }} href="http://gestioncurso.espol.edu.ec" title="Cick para acceder al sistema de Gestión de Cursos">
                                    //                <img src="https://www.profesor.espol.edu.ec/Content/Images/portal_min/gestion_min.png" alt="Gestión" de="" cursos="" className="block-portal-imagen" style={{ borderColor: "#d2d2d2" }} />
                                    //            </a>
                                    //        </div>
                                    //        <div className="wg_espol_block_portal">
                                    //            <a className="wg_a" style={{ padding: "0 !important" }} href="https://talentohumano.espol.edu.ec/login.aspx" title="Cick para acceder al sistema de Talento Humano">
                                    //                <img src="https://www.profesor.espol.edu.ec/Content/Images/portal_min/talento_min.png" alt="Talento" humano="" className="block-portal-imagen" style={{ borderColor: "#F5b400" }} />
                                    //            </a>
                                    //        </div>
                                    //    </div>
                                    //</div>
                                }



                                {
                                    this.state.currentUser && this.state.currentUser.usuario ?
                                        <span>

                                        </span> :
                                        <React.Fragment>
                                            <a href="#" onClick={() => this.login()} className="nav-item nav-link" style={{ color: "#FFC200" }}>
                                                Iniciar sesión &nbsp;
                                                <InicarSesionIcon className="loginIcon" />

                                            </a>

                                            <a id="widgetsistemas" title="Aplicaciones" className="opcionesIconNoLogin"></a>
                                        </React.Fragment>





                                }
                                {/* // <div></div>
                                    //     :
                                    //     <div>
                                    //         <span>
                                    //         <a href="#" onClick = {() => this.login()} className="nav-item nav-link" style={{ color: "#FFC200" }}>
                                    //             Iniciar sesión &nbsp;
                                              
                                    //                 <InicarSesionIcon className="loginIcon"/>

                                                
                                    //         </a>
                                            
                                    //     </span>
                                    //         <span className="mr-2" id="menu_espol">
                                    //             <a id="widgetsistemas"  title="Aplicaciones"></a>
                                    //         </span>
                                    //     </div> */}



                            </div>
                            {/* <span><a href="#" onClick={() => this.logout()} className="nav-item nav-link salir" style={{ color: "#FFC200" }}><i className="fas fa-door-open"></i></a></span> */}

                        </div>{/*console.log('currentuser=' + JSON.stringify(this.state.currentUser))*/}
                        {/* <button
                            type="button"
                            ref={this.sidebarToggle}
                            className="navbar-toggler"
                            onClick={() => this.openSidebar()}
                        >
                            <span className="navbar-toggler-bar bar1" />
                            <span className="navbar-toggler-bar bar2" />
                            <span className="navbar-toggler-bar bar3" />
                        </button> */}


                    </Container>
                </Navbar>
                {existe_dato_usuario &&
                    <Container fluid={true} className="mt-2 mb-3">
                        <Row>
                            <Col xs={{ size: 12, offset: 0 }} sm={{ size: 5, offset: 7 }} md={{ size: 4, offset: 8 }} xl={{ size: 4, offset: 8 }} lg={{ size: 4, offset: 8 }}>
                                <Row className="justify-content-end">
                                    {iconos_navegacion}
                                </Row>
                            </Col>
                        </Row>
                    </Container>
                }


                {/* <div>
                {iconos_navegacion}
            </div> */}
            </React.Fragment>

        );
    }
}

export default Header;
